module.exports = __webpack_public_path__ + "static/media/home_bg.59c03b7a.jpg";